import React from 'react';

import { WpDropdown, WpDropdownToggle, WpDropdownMenu, WpDropdownMenuItem } from 'Wpds/components/dropdown';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

import { downloadFile } from 'Shared/helpers';
import { downloadFileInZoom } from 'Shared/utils/Attachment.utils';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  attachment: {
    id: number;
    isImage: boolean;
    url: string;
    fileName: string;
    user?: {
      id: number;
    };
  };
  onRemoveClick?: Function;
  showPreviewOption?: boolean;
  isShowPreview?: boolean;
  handleTogglePreview?: Function;
};

const AttachmentSmartMenu = ({
  attachment,
  onRemoveClick = null,
  showPreviewOption = false,
  isShowPreview = false,
  handleTogglePreview,
}: Props) => {
  const { user: currentUser } = useCurrentUser();
  const { isZoom } = useApp();
  const { tr } = useTranslation();

  const handleDownload = () => {
    if (isZoom) {
      downloadFileInZoom(attachment.url);
    } else {
      downloadFile({ url: attachment.url, filename: attachment.fileName });
    }
  };

  const { isImage } = attachment;

  const isPreivewOptionEnabled = showPreviewOption && handleTogglePreview && isImage;
  const canRemoveAttachment = onRemoveClick && attachment.user?.id === currentUser.id;

  return (
    <div className="position-absolute" style={{ right: 0 }}>
      <WpDropdown>
        <WpDropdownToggle>
          <WpButton variant="tertiary" size="sm">
            <WpIcon name="ellipsis-v-alt" />
          </WpButton>
        </WpDropdownToggle>
        <WpDropdownMenu>
          {isPreivewOptionEnabled && isShowPreview && (
            <WpDropdownMenuItem onClick={handleTogglePreview}>
              <WpIcon name="eye-slash" />
              {tr('perform.attachments.actions.hide_preview')}
            </WpDropdownMenuItem>
          )}
          {isPreivewOptionEnabled && !isShowPreview && (
            <WpDropdownMenuItem onClick={handleTogglePreview}>
              <WpIcon name="eye" />
              {tr('perform.attachments.actions.show_preview')}
            </WpDropdownMenuItem>
          )}
          <WpDropdownMenuItem onClick={handleDownload}>
            <WpIcon name="download" />
            {tr('perform.attachments.actions.download')}
          </WpDropdownMenuItem>
          {canRemoveAttachment && (
            <WpDropdownMenuItem color="danger" onClick={onRemoveClick}>
              <WpIcon name="trash" />
              {tr('perform.attachments.actions.delete')}
            </WpDropdownMenuItem>
          )}
        </WpDropdownMenu>
      </WpDropdown>
    </div>
  );
};

export default AttachmentSmartMenu;
